import * as z from 'zod';
import { Get as Get$1, Import as Import$1, Close as Close$1 } from './admin-bid-contract-surety-bond.dto.mjs';
import * as adminBidContractSuretyBond_dto from './admin-bid-contract-surety-bond.dto.mjs';
export { adminBidContractSuretyBond_dto as Bid };
import { Import as Import$3 } from './admin-bid-to-final-contract-surety-bond.dto.mjs';
import * as adminBidToFinalContractSuretyBond_dto from './admin-bid-to-final-contract-surety-bond.dto.mjs';
export { adminBidToFinalContractSuretyBond_dto as BidToFinal };
import { Get as Get$2, Import as Import$2, Close as Close$2 } from './admin-final-contract-surety-bond.dto.mjs';
import * as adminFinalContractSuretyBond_dto from './admin-final-contract-surety-bond.dto.mjs';
export { adminFinalContractSuretyBond_dto as Final };

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.discriminatedUnion("contractSuretyType", [
            Get$1.Response.schema,
            Get$2.Response.schema,
        ]);
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Import;
(function (Import) {
    (function (Request) {
        Request.schema = z.discriminatedUnion("contractSuretyType", [
            Import$1.Request.schema,
            Import$2.Request.schema,
            Import$3.Request.schema,
        ]);
    })(Import.Request || (Import.Request = {}));
})(Import || (Import = {}));
var Close;
(function (Close) {
    (function (Request) {
        Request.schema = z.discriminatedUnion("contractSuretyType", [
            Close$1.Request.schema,
            Close$2.Request.schema,
        ]);
    })(Close.Request || (Close.Request = {}));
})(Close || (Close = {}));

export { Close, Get, Import };
